module.exports = __webpack_public_path__ + "static/media/img-1.6e248bff.png";